import { ReactNode } from 'react'

interface Props {
    error: boolean
    hasItems: boolean
    children: ReactNode
}

/**
 * Decides what the orders list shows: an error state, an empty state or the
 * content. On error the content is never rendered, so partial or stale data is
 * not presented as current (SM-1117).
 */
const OrdersListStatus = ({ error, hasItems, children }: Props) => {
    if (error) {
        return (
            <div role="alert" className="flex justify-center p-4 text-sm text-[#B42318]">
                No se pudieron cargar las órdenes. Intentá nuevamente.
            </div>
        )
    }

    if (!hasItems) {
        return (
            <div className="flex justify-center p-4 text-sm">
                no hay órdenes para mostrar
            </div>
        )
    }

    return <>{children}</>
}

export default OrdersListStatus
